<div class="page-layout carded left-sidenav toolbar-fixed-layout">

  <div class="flex flex-col h-p-100 w-p-100">
    <mat-tab-group  class="absolute-container  full-grow-no-shrink-no-basis " (selectedIndexChange)="onTabChange($event)">
      <mat-tab label="Government Websites">

        <div class="stage">

          <!--              <mat-form-field appearance="outline" style="margin-bottom:0!important" class="w-p-50 p-t-30 p-lr-30">-->
          <!--                <mat-label>Search by country name</mat-label>-->
          <!--                <input  formControlName="value" matInput-->
          <!--                        particleAnalytics-->
          <!--                        analyticsCategory= "string-input-dialog-box">-->
          <!--              </mat-form-field>-->


          <div class="alphabate-listing m-t-30">
            <div class="all m-r-24">
              <a style="cursor: pointer" [ngClass]="selectedAlphabet === 'ALL' ? 'active' : ''"
                 (click)="UpdateByAlphabet('ALL')"> All</a>
            </div>
            <ul>
              <li class="alphabate" *ngFor="let alphabet of alphabets">
                <a style="cursor: pointer" [ngClass]="selectedAlphabet === alphabet ? 'active' : ''"
                   (click)="UpdateByAlphabet(alphabet)">{{ alphabet }}</a>
              </li>
            </ul>
          </div>
          <div class="plate flex flex-row ">
            <div class="section" *ngFor="let group of groups"
                 [ngClass]="selectedAlphabet !== 'ALL' ? 'single_section' : ''">
              <div class="cube" *ngFor="let items of group">
                <div class="alphabate">{{ items.alphabet }}</div>
                <div class="flex flex-row flex-wrap">
                  <table *ngFor="let item of items.groupItems">
                    <tr>
                      <th> {{item.groupTitle}}</th>
                    </tr>
                    <tr *ngFor="let website of item.websites">
                      <td>
                        <div class="flex flex-row justify-between items-center">
                          <a href="{{website.url}}" target="_blank">{{website.title}}</a>
                          <span class="language">
                      <a href="{{website.url}}" target="_blank">
                        <i class="far fa-language"></i> {{website.language}}
                      </a>
                    </span>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Other Websites">
        <div class="stage">
          <div class="alphabate-listing m-t-30">
            <div class="all m-r-24">
              <a style="cursor: pointer" [ngClass]="selectedAlphabet === 'ALL' ? 'active' : ''"
                 (click)="UpdateByAlphabet('ALL')"> All</a>
            </div>
            <ul>
              <li class="alphabate" *ngFor="let alphabet of alphabets">
                <a style="cursor: pointer" [ngClass]="selectedAlphabet === alphabet ? 'active' : ''"
                   (click)="UpdateByAlphabet(alphabet)">{{ alphabet }}</a>
              </li>
            </ul>
          </div>
          <div class="plate flex flex-row ">
            <div class="section" *ngFor="let group of groups"
                 [ngClass]="selectedAlphabet !== 'ALL' ? 'single_section' : ''">
              <div class="cube" *ngFor="let items of group">
                <div class="alphabate">{{ items.alphabet }}</div>
                <div class="flex flex-row flex-wrap">
                  <table *ngFor="let item of items.groupItems">
                    <tr>
                      <th> {{item.groupTitle}}</th>
                    </tr>
                    <tr *ngFor="let website of item.websites">
                      <td>
                        <div class="flex flex-row justify-between items-center">
                          <a href="{{website.url}}" target="_blank">{{website.title}}</a>
                          <span class="language">
                      <a href="{{website.url}}" target="_blank">
                        <i class="far fa-language"></i> {{website.language}}
                      </a>
                    </span>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
